<div class="modal-header">
    <h4 class="modal-title" translate="services.activation.title"></h4>

    <button class="btn-close" aria-label="Close"
            (click)="activeModal.dismiss('Cross click')">
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="activateForm">
        <div class="row">
            @if (measuringPoint) {
                <div class="col-12 col-lg-6">
                    <label class="form-label">{{ 'services.activation.form.designation' | translate }}</label>
                    <p>{{ measuringPoint['name' + crtLang.toUpperCase()] }}</p>
                </div>

                <div class="col-12 col-lg-6">
                    <label class="form-label">{{ 'services.activation.form.state' | translate }}</label>
                    <p>{{ 'common.measuringPointUsageState.' + measuringPoint.measuringPointUsageState | translate }}</p>
                    @if (measuringPoint.measuringPointUsageState !== MeasuringPointUsageState.Free) {
                        <app-form-error
                            invalidKey="services.activation.form.invalidState"></app-form-error>
                    }
                </div>
            }

            @if (customerId || hasVisitorAccess) {
                <div class="col-12 col-lg-6">
                    <label class="form-label">{{ 'services.activation.form.tariff' | translate }}</label>
                    <p>{{ displayedTariff.tariffConfig['label' + crtLang.toUpperCase()] }}</p>
                </div>

                <div class="col-12 col-lg-6">
                    <label class="form-label">{{ 'services.activation.form.price' | translate }}</label>
                    @if (displayedTariff.customUnitFR) {
                        @for (price of displayedTariff.tariffPrices; track price) {
                            <p class="mb-0">
                                {{ price.priceByUnit | currencyFormat }}
                                / {{ displayedTariff['customUnit' + crtLang.toUpperCase()] }}
                            </p>
                        }
                    }

                    @if (!displayedTariff.customUnitFR) {
                        @for (price of displayedTariff.tariffPrices; track price) {
                            <p class="mb-0">
                                {{ price.priceByUnit | currencyFormat }}
                                / {{ 'common.units.' + price.tariffConfigUnit.unitEnumName + '.' + price.tariffConfigUnit.unitEnumValue | translate }}
                            </p>
                        }
                    }
                </div>

                <div class="col-12 col-lg-6">
                    <label class="form-label">
                        {{ 'services.impulseDuration' | translate }}

                        @if (isExploitant) {
                            <span>*</span>
                        }
                    </label>

                    @if (isExploitant) {
                        <input class="form-control" id="impulseDuration" type="number"
                               pattern="^[0-9]*$"
                               (keypress)="FormUtils.validateInputNumberLength($event, 8)"
                               name="impulseDuration" min="1"
                               formControlName="impulseDuration">
                        <app-form-error [control]="impulseDuration"></app-form-error>
                    } @else {
                        <p>{{ activationDuration }}</p>
                    }
                </div>

                <div class="col-12 col-lg-6">
                    <label class="form-label">{{ 'services.activation.form.unit' | translate }}</label>
                    <p>{{ 'common.impulseDurationUnit.' + activationUnit | translate }}</p>
                </div>

                <!-- Visitor Form -->
                @if (!loggedIn) {
                    <div>
                        <app-customer-data-form #customerDataFormComponent
                                            [contactForm]="visitorForm"></app-customer-data-form>
                    </div>
                }

                @if (isExploitant) {
                    <div class="col-12">
                        <label class="form-label">{{ 'services.activation.form.user' | translate }}*</label>
                        <app-search-customer
                            (selectedCustomerEvent)="customerSelected($event)"></app-search-customer>
                    </div>
                }

                @if (availablePaymentTypes.length > 1) {
                    <div class="col-12">
                        <label class="form-label">{{ 'common.terms.paymentType' | translate }}*</label>
                        <div>
                            <app-payment-type-chooser #paymentTypeChooserComponent
                                                      [availablePaymentTypes]="availablePaymentTypes"
                                                      (selectedPaymentType)="selectPaymentType($event)"></app-payment-type-chooser>
                        </div>
                        <app-form-error [control]="paymentType"></app-form-error>
                    </div>
                }

                <app-show-cgv [formGroup]="activateForm"></app-show-cgv>
            }

            @if (!loggedIn) {
                @if (!hasVisitorAccess) {
                    <div class="row">
                        <p translate="services.activation.message.loggedOnly"></p>
                    </div>
                }

                <div class="btn-bar">
                    <button class="btn btn-primary"
                            (click)="login()"
                            translate="menu.login"></button>
                </div>
            }
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary"
            (click)="activeModal.close()"
            translate="common.cancel">
    </button>
    <button type="submit" class="btn btn-primary"
            (click)="activateService()"
            [disabled]="activateForm.invalid || measuringPoint?.measuringPointUsageState !== MeasuringPointUsageState.Free"
            translate="common.activate">
    </button>
</div>




